
import { clearAuthFromStorage } from 'src/lib/auth-storage';

/**
 * Centralized logout utility for handling logout from API interceptors
 * and other non-component contexts
 */
export const performLogout = (redirectToSignIn = true, showExpiredMessage = false) => {
  console.log('performLogout called with:', { redirectToSignIn, showExpiredMessage });
  
  // Clear auth storage
  clearAuthFromStorage();
  console.log('Auth storage cleared');
  
  // Clear token expiration tracking
  localStorage.removeItem('token_expires_at');
  console.log('Token expiration cleared');
  
  // Clear any other auth-related localStorage items
  localStorage.removeItem('token_expires_at');
  
  // Redirect to sign-in page
  if (redirectToSignIn) {
    const url = showExpiredMessage ? '/sign-in?reason=session_expired' : '/sign-in';
    console.log('Redirecting to:', url);
    
    // Use location.href for a full page refresh to ensure complete state reset
    window.location.href = url;
  }
};

// Public routes that don't require authentication redirects
const PUBLIC_ROUTES = ['/', '/sign-in', '/register', '/forgot-password'];

/**
 * Check if the current page is a public route
 */
const isPublicRoute = (): boolean => {
  const { pathname } = window.location;
  // Check exact matches
  if (PUBLIC_ROUTES.includes(pathname)) return true;
  // Check for portfolio pages which should also be public
  if (pathname.startsWith('/portfolio/')) return true;
  return false;
};

/**
 * Handle API-triggered logouts (e.g., from 401 responses).
 * Only redirects to sign-in with session_expired message if user is on a protected route.
 * On public routes, just clears auth storage without redirect.
 */
export const performLogoutWithFallback = () => {
  console.log('performLogoutWithFallback called');

  // Clear auth storage first
  clearAuthFromStorage();
  localStorage.removeItem('token_expires_at');

  // Only redirect to sign-in with session_expired if user is on a protected route
  // If on a public route (like landing page), just clear auth - no redirect needed
  if (!isPublicRoute()) {
    console.log('On protected route, redirecting to sign-in with session_expired');
    window.location.href = '/sign-in?reason=session_expired';
  } else {
    console.log('On public route, auth cleared but no redirect needed');
  }
};